export const questionCategories = {
    Free: 0,
	Default: 0,
    System: 1,
    Demographics: 2,
    Netquest: 3,
    DynamicDemographic: 4,
    Honeypot: 5
}